export default {
  columns: {
    version: 'Version',
    signed_at: 'Underskrevet den',
    internal_note: 'Intern note',
    signature_provider: 'Signaturudbyder',
    file: 'Dokument',
    actions: 'Handlinger',
  },
  labels: {
    version: 'v{{version}}',
    no_history: 'Ingen signaturhistorik endnu',
    providers: {
      selfhosted: 'Selvhostet',
      yousign: 'Yousign',
    },
  },
  buttons: {
    preview: 'Forhåndsvisning',
    download: 'Download',
  },
};
